import React from "react";
import styled, { useTheme } from "styled-components";
import { Environment } from "@core/config/environment";
import { Card, CardTitle, Section, SectionIntro, SectionTitle } from "./debugUi";

function isGradient(key: string, value: string): boolean {
	return key.toLowerCase().includes("gradient") || value.includes("deg");
}

export const ColorsSection: React.FC = () => {
	const theme = useTheme();
	const entries = Object.entries(theme.colors);

	return (
		<Section id="colors">
			<SectionTitle>Couleurs</SectionTitle>
			<SectionIntro>Palette active : {Environment.APP_VARIANT}. Les dégradés sont des arrêts CSS.</SectionIntro>
			<Grid>
				{entries.map(([name, value]) => {
					const gradient = isGradient(name, value);
					return (
						<Swatch key={name}>
							<Chip $gradient={gradient} style={{ background: gradient ? `linear-gradient(${value})` : value }} />
							<Name>{name}</Name>
							<Value>{value}</Value>
						</Swatch>
					);
				})}
			</Grid>
		</Section>
	);
};

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
	gap: 12px;
`;

const Swatch = styled(Card)`
	padding: 10px;
	gap: 8px;
`;

const Chip = styled.div<{ $gradient: boolean }>`
	height: ${({ $gradient }) => ($gradient ? 56 : 48)}px;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.lightergray};
`;

const Name = styled(CardTitle)`
	font-size: 0.8rem;
	word-break: break-word;
`;

const Value = styled.code`
	font-size: 0.7rem;
	color: ${({ theme }) => theme.colors.textSecondary};
	word-break: break-all;
`;
